export default "__VITE_ASSET__ChlC9W6$__"